import styled from 'styled-components'

const CanvasContainer = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
  background: #fafbfc;
  height: 100%;
`

const CanvasWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
`

const Canvas = styled.canvas`
  display: block;
  cursor: crosshair;
  width: 100%;
  height: 100%;

  &.select-cursor {
    cursor: default;
  }

  &.pan-cursor {
    cursor: grab;
  }

  &.pan-cursor:active {
    cursor: grabbing;
  }
`

const CanvasOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
`

const ZoomControls = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: white;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

const ZoomButton = styled.button`
  width: 32px;
  height: 32px;
  border: 1px solid #d0d7de;
  border-radius: 4px;
  background: white;
  color: #24292f;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;

  &:hover {
    background: #f6f8fa;
  }

  &:active {
    background: #f1f3f6;
  }
`

const CoordinatesDisplay = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  background: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  color: #656d76;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

const ContextMenu = styled.div<{ x: number; y: number }>`
  position: fixed;
  top: ${props => props.y}px;
  left: ${props => props.x}px;
  background: white;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 120px;
`

const ContextMenuItem = styled.button`
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: none;
  text-align: left;
  font-size: 12px;
  cursor: pointer;

  &:hover {
    background: #f6f8fa;
  }

  &:first-child {
    border-radius: 6px 6px 0 0;
  }

  &:last-child {
    border-radius: 0 0 6px 6px;
  }

  &:only-child {
    border-radius: 6px;
  }
`

export {
  CanvasContainer,
  CanvasWrapper,
  Canvas,
  CanvasOverlay,
  ZoomControls,
  ZoomButton,
  CoordinatesDisplay,
  ContextMenu,
  ContextMenuItem,
}
